import { useEditor, useNode } from "@craftjs/core";
import { useRef } from "react";
import ContentEditable from "react-contenteditable";
import Settings from "./Settings";

interface HomeHeadingProps {
    text: string;
    anchorTag?: string;
}

const getPlainText = (html: string): string => {
    const template = document.createElement("template");
    template.innerHTML = html || "";

    const walker = document.createTreeWalker(template.content, NodeFilter.SHOW_TEXT, null);
    let content = "";
    let node;
    while ((node = walker.nextNode())) {
        content += node.textContent;
    }

    return content;
};

const HomeHeading = ({ text, anchorTag: anchorBadge = "" }: Partial<HomeHeadingProps>) => {
    const editableRef = useRef<HTMLDivElement | null>(null);

    const {
        connectors: { connect },
        actions: { setProp },
    } = useNode((node) => ({
        parentNodeId: node.data.parent,
    }));

    const { enabled } = useEditor((state) => ({
        enabled: state.options.enabled,
    }));

    const plainText = getPlainText(text || "");

    return (
        <div
            ref={(ref) => connect(ref!)}
            className="craftjs-heading w-full -mb-5"
            style={{
                minHeight: enabled ? (text ? "unset" : "1rem") : "unset",
            }}
        >
            <span className="craftjs-heading-anchor" data-anchor-label={plainText} data-anchor-tag={anchorBadge} />

            <ContentEditable
                html={text || ""}
                innerRef={editableRef}
                disabled={!enabled}
                onChange={(e) => {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    setProp((props: any) => (props.text = e.target.value), 500);
                }}
                tagName={`h2`}
                className="font-bold text-[45px] text-primary-500"
            />
        </div>
    );
};

export default HomeHeading;

HomeHeading.craft = {
    displayName: "Heading",
    props: {
        margin: [0, 0, 0, 0],
        text: "Text",
        anchorTag: "",
    },
    related: {
        settings: Settings,
    },
};
